import Chart from 'react-apexcharts';
import PropTypes from 'prop-types';
import { Card, Typography, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as moment from 'moment';
import { lightVeil, darkVeil, grey } from '../../theme/tones';

const CampaignTime = (props) => {
  const theme = useTheme();
  const { timeToPass, averageTime, ...other } = props;
  const items = [
    {
      color: theme.palette.success.main,
      label: 'Total de temps passé',
      value: moment.utc(timeToPass * 1000).format('HH:mm:ss')
    },
    {
      color: theme.palette.warning.main,
      label: 'Moyenne de temps passé',
      // pour enlever les millisecondes
      value: Number.isNaN(averageTime) ? '00:00:00' : moment.utc(averageTime * 1000).format('HH:mm:ss')
    },
  ];

  const chartOptions = {
    chart: {
      background: 'transparent',
      stacked: false,
      toolbar: {
        show: false
      }
    },
    labels: ['TEMPS'],
    plotOptions: {
      radialBar: {
        dataLabels: {
          name: {
            show: true,
            color: theme.palette.text.secondary,
            fontSize: '12px',
            fontWeight: 600,
            offsetY: 20
          },
          value: {
            color: theme.palette.text.primary,
            fontSize: '18px',
            fontWeight: 800,
            offsetY: -20,
            formatter(value) {
              return value;
            },
          },
        },
        hollow: {
          size: '60%'
        },
        track: {
          background: theme.palette.mode === 'light' ? grey(100) : lightVeil(0.05)
        }
      }
    },
    states: {
      active: {
        filter: {
          type: 'none',
          value: 0
        }
      },
      hover: {
        filter: {
          type: 'none',
          value: 0
        }
      }
    },
    theme: {
      mode: theme.palette.mode
    }
  };

  return (
    <Card
      {...other}
      sx={{
        borderRadius: '24px',
        boxShadow: `0 4px 18px 0 ${darkVeil(0.03)}`,
        border: '1px solid',
        borderColor: 'divider',
        overflow: 'hidden',
        ...other.sx
      }}
    >
      <Grid
        container
        spacing={3}
        sx={{ p: 3 }}
      >
        {items.map((item) => (
          <Grid
            item
            key={item.label}
            md={6}
            xs={12}
          >
            <Card
              sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                p: 3,
                borderRadius: '20px',
                borderColor: 'divider',
                backgroundColor: theme.palette.mode === 'light' ? grey(50) : lightVeil(0.01),
              }}
              variant="outlined"
            >
              <Typography
                sx={{ color: item.color, fontWeight: 700, mb: 1 }}
                variant="subtitle2"
              >
                {item.label}
              </Typography>
              <Chart
                height={230}
                options={{
                  ...chartOptions,
                  colors: [item.color],
                  legend: {
                    show: false,
                  }
                }}
                series={[item.value]}
                type="radialBar"
              />
            </Card>
          </Grid>
        ))}
      </Grid>
    </Card>
  );
};
CampaignTime.propTypes = {
  timeToPass: PropTypes.number.isRequired,
  averageTime: PropTypes.number.isRequired,
};

export default CampaignTime;
